import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TipoPagamentoDetalharComponent } from './tipo-pagamento-detalhar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: TipoPagamentoDetalharComponent }
    ])],
    exports: [RouterModule]
})
export class TipoPagamentoDetalharRoutingModule { }
